const STORAGE_KEY = 'sb_symbol_usage';

function loadUsages(): Record<string, number> {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {
        return {};
    }
}

export function recordSymbolUsage(key: string): void {
    try {
        const usages = loadUsages();
        usages[key] = (usages[key] || 0) + 1;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(usages));
    } catch { /* storage blocked */ }
}

export function getSymbolUsages(): Record<string, number> {
    return loadUsages();
}

/** Stable key for a symbol: prefer id, fall back to latex string. */
export function symbolKey(symbol: { id?: string; latex: string }): string {
    return symbol.id || symbol.latex;
}
